/** /[locale]/ */
export const _PATHNAME = (locale: string | string[]) => '/[locale]/'.replace('[locale]', String(locale));

// Auth

/** /[locale]/login/ */
export const LOGIN_PATHNAME = (locale: string | string[]) => '/[locale]/login/'.replace('[locale]', String(locale));
/** /[locale]/signup/ */
export const SIGNUP_PATHNAME = (locale: string | string[]) => '/[locale]/signup/'.replace('[locale]', String(locale));

export const AUTH_GOOGLE_PATHNAME = '/auth/google/';

// Business Account

/** /[locale]/business/account/create/ */
export const BUSINESS_ACCOUNT_CREATE_PATHNAME = (locale: string | string[]) =>
	'/[locale]/business/account/create/'.replace('[locale]', String(locale));
/** /[locale]/business/account/inquire/ */
export const BUSINESS_ACCOUNT_INQUIRE_PATHNAME = (locale: string | string[]) =>
	'/[locale]/business/account/inquire/'.replace('[locale]', String(locale));
/** /[locale]/business/account/success/ */
export const BUSINESS_SUCCESS_PATHNAME = (locale: string | string[]) =>
	'/[locale]/business/account/success/'.replace('[locale]', String(locale));
/** /[locale]/business/account/ */
export const BUSINESS_ACCOUNT_MAIN_PATHNAME = (locale: string | string[]) =>
	'/[locale]/business/account/'.replace('[locale]', String(locale));

// Tournament

/** /[locale]/tournament/create/ */
export const TOURNAMENT_CREATE_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/create/'.replace('[locale]', String(locale));
/** /[locale]/tournament/create/new/ */
export const TOURNAMENT_CREATE_NEW_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/create-new/'.replace('[locale]', String(locale));
/** /[locale]/tournament/inquiries/ */
export const TOURNAMENT_INQUIRIES_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/inquiries/'.replace('[locale]', String(locale));
/** /[locale]/tournament/manage/ */
export const TOURNAMENT_MANAGE_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/manage/'.replace('[locale]', String(locale));
/** /[locale]/tournament/edit/ */
export const TOURNAMENT_EDIT_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/edit/'.replace('[locale]', String(locale));
/** /[locale]/tournament/details/ */
export const TOURNAMENT_DETAILS_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/details/'.replace('[locale]', String(locale));
/** /[locale]/tournament/details/round/ */
export const TOURNAMENT_DETAILS_ROUND_PATHNAME = (locale: string | string[]) =>
	'/[locale]/tournament/details/round/'.replace('[locale]', String(locale));

// Callback

/** /[locale]/callback/ */
export const CALLBACK_PATHNAME = (locale: string | string[]) =>
	'/[locale]/callback/'.replace('[locale]', String(locale));
